import React from 'react';
import { Row } from 'antd';
import moment from 'moment';
import { DataLabelRight } from './dataLabelRight';
import { TitleTabs } from './titleTabs';

export function RightTab({ dataScreen }) {
  return <>
    <TitleTabs title="Viagens" dataScreen={dataScreen} />
    <Row span={24}>
      <DataLabelRight
        span={8}
        title="Total de viagens"
        label={
          dataScreen.totalViagens > 1
            ? `${dataScreen.totalViagens} viagens`
            : `${dataScreen.totalViagens} viagem`
        }
      />
      <DataLabelRight
        span={8}
        title="Tipo de carga"
        label={dataScreen.produtoUltimaViagem}
      />
      <DataLabelRight
        span={8}
        title="Data da última viagem"
        label={moment(dataScreen.dataUltimaViagem).format('DD/MM/YYYY')}
      />
      <DataLabelRight
        span={8}
        title={`Viagens nos últimos ${dataScreen.diasIntervalo} dias`}
        label={
          dataScreen.totalViagensPeriodo > 1
            ? `${dataScreen.totalViagensPeriodo} viagens`
            : `${dataScreen.totalViagensPeriodo} viagem`
        }
      />
    </Row>
         </>;
}
